//@ts-nocheck
import React, { useEffect, useState } from "react";
import styles from "./UploadFromPhotoLog.module.scss";
import { Button } from "@factorearth/component-library";
import { useTheme } from "../../../../hooks/useSingleton";
import { getCorrectS3Url } from "../../../../utils/s3/getCorrectS3Url";
import { recordSentry } from "utils/recordSentry";
import { TextFieldWrapper } from "@factorearth/component-library";
import _getPhotoLogsByProject from "utils/_getPhotologsByProject";
import { getImageBinaryById } from "db/queries/imageBinaryQueries";

/**
 * The component for a menu to upload images into a form from the photolog
 * @param {Object} props
 * @param {Array} props.photologs the photolog form groups that were retrieved and filtered out.
 * @param {FieldTemplate} props.template
 * @param {Function} cb (callback) to be called on submit
 */
function UploadFromPhotoLog(props) {
	const { cancel, imageRollInstance, online, projectId, template, cb } = props;

	const [filterSearch, setFilterSearch] = useState("");
	const [searchOption, setSearchOption] = useState("NONE");
	const [photologs, setPhotologs] = useState([]);
	const [photologHtml, setPhotologHtml] = useState([]);
	const [moreInfo, setMoreInfo] = useState([]);
	const [selectedRowsIds, setSelectedRowsIds] = useState([]);
	const [selectedRowsData, setSelectedRowsData] = useState([]);
	const color = useTheme();

	useEffect(() => {
		async function getPhotologs() {
			const retrievedPhotologs = await _getPhotoLogsByProject(projectId, imageRollInstance, online);
			setPhotologs(retrievedPhotologs);
		}
		getPhotologs();
	}, []);

	// To put the logs in the dom and update when the user selects them.
	useEffect(() => {
		renderLogs();
	}, [selectedRowsIds, photologs]);

	/**
	 * Renders all the photologs that are passed in as selectable images.
	 */
	async function renderLogs() {
		let final = [];
		let rowMap = {};
		for (let i = 0; i < photologs.length; i++) {
			const photolog = photologs[i];
			let photos = [];
			// setup field m ap for all the rows so first need to find the imageroll field, then loop
			// through its tablefields
			for (let f = 0; f < photolog.formInstances.items.length; f++) {
				const formInstance = photolog.formInstances.items[f];

				for (let j = 0; j < formInstance.fieldInstances.items.length; j++) {
					const field = formInstance.fieldInstances.items[j];
					if (field.fieldTemplate.inputType === "imageroll") {
						// map out all teh fields in a row into a map with the fieldsOrder as the key
						for (let k = 0; k < field.tableFields.items.length; k++) {
							const tableField = field.tableFields.items[k];

							let rowKey;

							for (let o = 0; o < field.fieldsOrder.length; o++) {
								const rowOrder = field.fieldsOrder[o];
								if (rowOrder.includes(tableField.id)) {
									// found the matching row entry!
									rowKey = rowOrder;
									break;
								}
							}

							if (!rowMap[rowKey]) {
								// need to initiate the row in the row map

								const rowObj = {
									rowKey,
									fields: [],
								};

								if (tableField.fieldTemplate.inputType === "image") {
									rowObj.image = tableField;
								} else {
									rowObj.fields = [tableField];
								}
								rowMap[rowKey] = rowObj;
							} else {
								// row is already in row map so just add field to either image
								// or rowFields
								if (tableField.fieldTemplate.inputType === "image") {
									rowMap[rowKey].image = tableField;
								} else {
									rowMap[rowKey].fields.push(tableField);
								}
							}
						}

						// now build out the html for each row based on the rowMap entry matched by the
						// fieldsOrder elements
						for (let k = 0; k < field.fieldsOrder.length; k++) {
							const rowKey = field.fieldsOrder[k];
							const rowObj = rowMap[rowKey];
							const html = setupImageHtml(rowObj);
							photos.push(html);
						}
					}
				}
			}
			const photosFinal = await Promise.all(photos);

			const finalHtml = (
				<div className={styles.photolog_wrapper} key={`Photolog-${photolog.id}`}>
					<div className={styles.photolog_name_wrapper}>{photolog.name}</div>
					<div className={styles.photosWrapper}>{photosFinal.length > 0 ? photosFinal : <div>no photos in log</div>}</div>
				</div>
			);

			final.push(finalHtml);
		}

		if (final.length < 1) {
			final.push(<div>NO PHOTOLOGS FOUND IN PROJECT!</div>);
		}

		setPhotologHtml(final);
		// return final;
	}

	/**
	 * Set up row data in the more info panel and sets the html in state
	 * @param {Object} rowObj containing the data from the row.
	 * @param {Object} rowObj.image field instance which contains its image document (image.image)
	 * @param {Array} rowObj.fields instances for the actual row data associated with an image.
	 */
	function handleMoreInfo(rowObj) {
		const final = [];
		// loop through the fields in rowObj
		// show the header and the current value
		const image = rowObj.image.image;
		for (let i = 0; i < rowObj.fields.length; i++) {
			const field = rowObj.fields[i];
			const html = (
				<div>
					{field.fieldTemplate.header}:{field.value}
				</div>
			);

			final.push(html);
		}

		const imageDataHtml = (
			<div>
				aspect: {image.aspectX} x {image.aspectY}
				<br />
				dpi: {image.dpi}
				<br />
				applied rotation: {image.rotation}
			</div>
		);

		final.push(imageDataHtml);

		setMoreInfo(final);
	}

	/**
	 * Handler for selecting an image and the row
	 * @param {Object} rowObj containing the row data.
	 * @param {String} rowObj.rowKey for the row (csv string of ids of instances in the row)
	 */
	function handleSelectRow(rowObj) {
		// add the id to selectedrowIds and the data to selectedRowdata state variables
		const selectedRowsIdsCopy = [...selectedRowsIds];
		const selectedRowsDataCopy = [...selectedRowsData];
		// get the index of the selected row in the selectedrowsIds
		const index = selectedRowsIdsCopy.indexOf(rowObj.rowKey);
		if (index !== -1) {
			// its already in there so actually needs to be removed from the lists
			selectedRowsIdsCopy.splice(index, 1);
			selectedRowsDataCopy.splice(index, 1);
		} else {
			// it needs to be added to the list
			selectedRowsIdsCopy.push(rowObj.rowKey);
			selectedRowsDataCopy.push(rowObj);
		}

		setSelectedRowsIds(selectedRowsIdsCopy);
		setSelectedRowsData(selectedRowsDataCopy);
	}

	/**
	 * Setup html to render an image row object in the selection list.
	 * @param {Object} rowObj of the row data.
	 * @returns html for the image in the selection list.
	 */
	async function setupImageHtml(rowObj) {
		let signedUrl;
		if (rowObj && rowObj.image?.image?.key) {
			if (online) {
				try {
					signedUrl = await getCorrectS3Url(rowObj.image?.image?.key);
				} catch (err) {
					recordSentry({ error: err, message: `Error getting image (does it exist?): ${rowObj.image?.image?.key}` });
				}
			} else {
				const imageBinaryDoc = await getImageBinaryById(rowObj.image?.image?.key);
				if (imageBinaryDoc) {
					const binary = imageBinaryDoc.binary;
					signedUrl = URL.createObjectURL(binary);
				} else {
					const err = new Error(`Error uploading image: ${rowObj.image?.image?.key} Image was not saved offline.`);
					recordSentry({ error: err, message: `Error uploading image: ${rowObj.image?.image?.key} Image was not saved offline.` });
				}
			}
		}
		function generateDescription(row) {
			let finalDescription = "";
			if (row && row.fields) {
				for (const field of row.fields) {
					const header = field.fieldTemplate.header;
					const value = field.value;
					if (header && value) finalDescription += `${header}: ${value}\n`;
				}
				return finalDescription;
			}
			return finalDescription;
		}

		const description = generateDescription(rowObj);
		// for this part just render each imagee out, then the fields will render
		// when one (i) icon or w.e is selected.
		if (rowObj) {
			const html = (
				<div
					style={{
						borderBottom: selectedRowsIds.includes(rowObj.rowKey) ? `2px solid ${color.text.tertiary}` : `1px dotted ${color.border.secondary}`,
					}}
					className={`${selectedRowsIds.includes(rowObj.rowKey) ? styles.image_selected : styles.image}`}
					key={`PhotologRow-${rowObj.rowKey}`}>
					{signedUrl && signedUrl !== null && signedUrl !== "" ? (
						<>
							<img alt={rowObj.image.image.key} className={styles.image_preview} src={signedUrl} />
							<div className={styles.imageBtn_wrapper}>
								<Button colorPalette={color} onClick={() => handleSelectRow(rowObj)}>
									Select
								</Button>
								<Button colorPalette={color} onClick={() => handleMoreInfo(rowObj)}>
									More Info
								</Button>
							</div>
						</>
					) : (
						<div>
							{description}
							{description ? (
								<Button colorPalette={color} onClick={() => handleSelectRow(rowObj)}>
									Select
								</Button>
							) : (
								"No Image Uploaded"
							)}
						</div>
					)}
				</div>
			);

			return html;
		}
	}

	/**
	 * handler for search filter text box changes.
	 * @param {Object} e event object
	 */
	function handleFilterSearchChange(e) {
		const { value } = e.target;
		setFilterSearch(value);
	}

	/**
	 * setup the html for the dropdown to select by field in the photolog
	 * @returns html for the search filter options
	 */
	function renderSearchOptions() {
		// all of the photologs should already be filtered out to be the correct type based on the
		// image roll field that needs to be added into
		// So if there are photologs grab the first one and build the options based on those templates

		const options = [];
		for (let i = 0; i < template.tableFields.items.length; i++) {
			const tableFieldTemplate = template.tableFields.items[i];
			const option = (
				<option key={`${tableFieldTemplate.id}`} template={tableFieldTemplate} value={`${tableFieldTemplate.rollLinkId}`}>
					{tableFieldTemplate.header}
				</option>
			);
			options.push(option);
		}

		const noneOption = (
			<option key={`NONE`} template={"NONE"} value={`NONE`}>
				None
			</option>
		);
		options.push(noneOption);
		return options;
	}

	/**
	 * handler for the dropdown search option (search by field dropdown) changes
	 * @param {Object} e event object
	 */
	function handleSearchOptionChange(e) {
		const { value } = e.target;
		setSearchOption(value);
	}

	/**
	 * filter search guy submit handler
	 */
	function submitFilterSearch() {
		// if the string is empty than we should just sort based on the field
		buildHtmlForFilteredRows(searchOption, filterSearch);
	}

	/**
	 * just reset the filter and the user input fields for the search filter
	 */
	function resetFilter() {
		setSearchOption("NONE");
		setFilterSearch("");
		renderLogs();
	}

	/**
	 * Sets up the list based on a search filter
	 * @param {String} fieldIdToSearchBy field template id to match the correct field instance.
	 * @param {String} valueToFilterBy value to match the field instance from image row.
	 */
	async function buildHtmlForFilteredRows(fieldIdToSearchBy, valueToFilterBy) {
		let final = [];
		let rowMap = {};
		for (let i = 0; i < photologs.length; i++) {
			const photolog = photologs[i];
			let photos = [];
			// setup field m ap for all the rows so first need to find the imageroll field, then loop
			// through its tablefields
			for (let f = 0; f < photolog.formInstances.items.length; f++) {
				const formInstance = photolog.formInstances.items[f];
				for (let j = 0; j < formInstance.fieldInstances.items.length; j++) {
					const field = formInstance.fieldInstances.items[j];
					if (field.fieldTemplate.inputType === "imageroll") {
						// map out all teh fields in a row into a map with the fieldsOrder as the key
						for (let k = 0; k < field.tableFields.items.length; k++) {
							const tableField = field.tableFields.items[k];
							let rowKey;
							// setup rowKey
							for (let o = 0; o < field.fieldsOrder.length; o++) {
								const rowOrder = field.fieldsOrder[o];
								if (rowOrder.includes(tableField.id)) {
									// found the matching row entry!
									rowKey = rowOrder;
									break;
								}
							}
							if (!rowMap[rowKey]) {
								// need to initiate the row in the row map

								const rowObj = {
									rowKey,
									fields: [],
								};

								if (tableField.fieldTemplate.inputType === "image") {
									rowObj.image = tableField;
								} else {
									rowObj.fields = [tableField];
								}
								rowMap[rowKey] = rowObj;
							} else {
								// row is already in row map so just add field to either image
								// or rowFields
								if (tableField.fieldTemplate.inputType === "image") {
									rowMap[rowKey].image = tableField;
								} else {
									rowMap[rowKey].fields.push(tableField);
								}
							}
						}

						// if you need to do something row based do it here...
						// now build out the html for each row based on the rowMap entry matched by the
						// fieldsOrder elements
						for (let k = 0; k < field.fieldsOrder.length; k++) {
							const rowKey = field.fieldsOrder[k];
							const rowObj = rowMap[rowKey];
							let shouldRender = false;
							for (let i = 0; i < rowObj.fields.length; i++) {
								const tableField = rowObj.fields[i];
								if (tableField.fieldTemplate.rollLinkId === fieldIdToSearchBy) {
									if (tableField.value === valueToFilterBy) {
										// ITS THE ONE!
										shouldRender = true;
									}
								}
							}

							if (shouldRender) {
								// if there is a row object then it must have made it in...
								const html = setupImageHtml(rowObj);
								photos.push(html);
							}
						}
					}
				}
			}
			const photosFinal = await Promise.all(photos);

			const finalHtml = (
				<div className={styles.photolog_wrapper}>
					<div className={styles.photolog_name_wrapper}>{photolog.name}</div>
					<div className={styles.photosWrapper}>{photosFinal.length > 0 ? photosFinal : <div>no photos in log</div>}</div>
				</div>
			);

			final.push(finalHtml);
		}
		setPhotologHtml(final);
	}

	/**
	 * Submit handler to submit the selections
	 */
	async function submitSelectedRows() {
		cancel();
		await cb(selectedRowsData);
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.image_chooser_wrapper}>
				<div style={{ borderBottom: `1px dotted ${color.border.primary}` }} className={styles.toolbar_wrapper}>
					<div className={styles.searchWrapper}>
						<TextFieldWrapper
							type="text"
							name="filter-search"
							onChange={handleFilterSearchChange}
							value={filterSearch}
							placeholder="Search by fields"
							colorPalette={color}
						/>
					</div>
					<div className={styles.toolBtns_wrapper}>
						<label className={styles.filterLabel} style={{ color: color.text.primary }}>
							Filter:
						</label>
						<select
							name="type"
							id="type"
							onChange={handleSearchOptionChange}
							value={searchOption}
							className={styles.select}
							style={{
								color: color.text.secondary,
								background: color.text.primary,
								border: `1px solid ${color.border.primary}`,
							}}>
							{renderSearchOptions()}
						</select>
						<Button colorPalette={color} variant="outlined" onClick={submitFilterSearch}>
							Apply Filter
						</Button>
						<Button colorPalette={color} variant="outlined" onClick={resetFilter}>
							Reset filter
						</Button>
						<Button colorPalette={color} variant="destructive" onClick={cancel}>
							Cancel Upload
						</Button>
						<Button colorPalette={color} variant="outlined" onClick={submitSelectedRows}>
							Submit Selected Rows
						</Button>
					</div>
				</div>
				<div className={styles.row}>
					<div
						style={{
							background: color.background.primary,
							color: color.text.primary,
							borderRight: `1px solid ${color.border.primary}`,
						}}
						className={styles.log_wrapper}>
						<div
							style={{
								borderBottom: `1px solid ${color.border.primary}`,
								background: color.background.primary,
							}}
							className={styles.log_header}>
							Select Photos from Photolog to Upload
							<div style={{ color: color.text.secondary }} className={styles.infoText}>
								When completed submit the selected Rows
							</div>
						</div>
						{photologHtml}
					</div>
					<div style={{ color: color.text.secondary }} className={styles.more_info_wrapper}>
						{moreInfo}
					</div>
				</div>
			</div>
		</div>
	);
}

export default UploadFromPhotoLog;
